import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTeleQuery } from './useTeleQuery';
import { useZipcode } from './useZipcodeQuery';
import { useOptions } from './useOptions';
import { handleSubmitForm } from '../function/submitHandler';
import { onUploadFile } from './onUploadFile';
import { breakdownSubsQuery } from '../../../../services/react-query/optionMasterQuery';

export const useGetClaimAddList = () => {
  const { control, setValue, getValues, watch, reset, handleSubmit } = useForm({});
  const fullName = watch('fullName');
  const isCreateNewAddress = watch('isCreateNewAddress');
  const selectedWarranty = watch('warrantyId');

  const { mutate: onCallTele, loading: isLoadingTele } = useTeleQuery({ reset, getValues });
  const { mutate: onCallZipCode, loading: isLoadingZipCode } = useZipcode({ reset, getValues });
  const { mutate: onAddClaim, loading: isLoadingToSave } = onUploadFile();

  const {
    addressFullOptions,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    addressData,
    warrantyOptions,
    breakdownOptions,
    selectedBreakdown,
  } = useOptions({
    watch,
  });

  const { data: breakdownSubsOptions } = breakdownSubsQuery({
    productType: selectedBreakdown,
  });

  const onEnterHandler = useCallback(
    async (value, item) => {
      switch (item?.name) {
        case 'telephone':
          reset({ telephone: getValues('telephone') });
          onCallTele(value);
          break;
        case 'zipcode':
          onCallZipCode(value);
          break;
        default:
          break;
      }
    },
    [getValues],
  );
  const onChangeAddress = (value) => {
    const addressSetNew = addressData?.find((item) => item?.customerAddressId === value);
    if (addressSetNew) {
      setValue('zipcode', addressSetNew?.zipcode);
      setValue('provinceId', {
        value: addressSetNew?.provinceId,
        label: addressSetNew?.provinceName,
      });
      setValue('districtId', {
        value: addressSetNew?.districtId,
        label: addressSetNew?.districtName,
      });
      setValue('subDistrictId', {
        value: addressSetNew?.subDistrictId,
        label: addressSetNew?.subDistrictName,
      });
      setValue('other', addressSetNew?.other);
    }
  };

  const onSubmit = (values) => {
    const valuesWithCustomerCode = {
      ...values,
      provinceId:
        typeof values.provinceId === 'object' ? values.provinceId.value : values.provinceId,
      districtId:
        typeof values.districtId === 'object' ? values.districtId.value : values.districtId,
      subDistrictId:
        typeof values.subDistrictId === 'object'
          ? values.subDistrictId.value
          : values.subDistrictId,
    };
    handleSubmitForm(valuesWithCustomerCode, onAddClaim);
  };

  useEffect(() => {
    setValue('zipcode', '');
    setValue('provinceId', '');
    setValue('districtId', '');
    setValue('subDistrictId', '');
    setValue('other', '');
    setValue('customerAddressId', '');
  }, [isCreateNewAddress]);

  useEffect(() => {
    setValue('breakdownId', '');
  }, [selectedWarranty, setValue]);

  const onChangeProduct = (value, item) => {
    switch (item?.name) {
      case 'warrantyId':
        setValue('breakdownId', '');
        setValue('breakdownSubId', '');
        setValue('warrantyMobileIds', []);
        setValue('warrantyMobileOtherReason', '');
        break;
      case 'breakdownId':
        setValue('breakdownSubId', '');
        break;
      default:
        break;
    }
  };

  return {
    control,
    setValue,
    getValues,
    fullName,
    watch,
    onEnterHandler,
    addressFullOptions,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    warrantyOptions,
    breakdownOptions,
    breakdownSubsOptions,
    onChangeAddress,
    onSubmit,
    handleSubmit,
    isLoadingToSave,
    isLoadingTele,
    isLoadingZipCode,
    addressData,
    isCreateNewAddress,
    handleSubmit,
    onChangeProduct,
  };
};
